import type { BrandJson } from "@coras-io/brand-tokens";
import {
  DEFAULT_CURRENCIES,
  DEFAULT_LOCALES,
  type SiteConfig,
} from "../../src/types";
import brandConfig from "./brand.json";

// Brand note: the original navbar and primary button were vertical gradients,
// collapsed here to representative solids (navbar #19417e, primary #008dc8). The
// navbar's `5px solid` green underline becomes the navbarBorder colour (#088f8a)
// - the width is the component default. Revisit on gradient token support.
export const brand = brandConfig as BrandJson;

export const site: SiteConfig = {
  distributorId: "2154f33c-4b33-45dc-bc1d-a1d4bf680ade",
  title: "Travelodge",
  description: "Book tickets to West End Shows, Concerts and more",
  locale: "en-US",
  currency: "USD",
  locales: DEFAULT_LOCALES,
  currencies: DEFAULT_CURRENCIES,
  favicons: [
    "apple-touch-icon.png",
    "favicon-16x16.png",
    "favicon-32x32.png",
    "favicon.ico",
  ],
  logo: "/assets/images/logo.png",
  domain: "experiences.travelodge.co.uk",
  detectLocale: true,
  detectCurrency: true,
};
